import { createSlice } from "@reduxjs/toolkit";
import { isUserDataComplete } from "utils/helpers/tokenHandler";
import vars from "utils/vars";

const initialState = {
	isAuthenticated: !!localStorage.getItem(vars.localStorage.fieldsName.token),
	user: JSON.parse(localStorage.getItem(vars.localStorage.fieldsName.user) || "{}") || {},
};

export const slice = createSlice({
	name: "auth",
	initialState,
	reducers: {
		updateUser: (state, { payload }) => {
			const updatedUser = { ...(state?.user || {}), ...(payload || {}) };
			localStorage.setItem(vars.localStorage.fieldsName.user, JSON.stringify(updatedUser));
			return { ...state, user: updatedUser };
		},
		updateAuthState: (state, { payload }) => {
			return { ...state, ...payload };
		},
		login: (state, { payload: { token, user } }) => {
			localStorage.setItem(vars.localStorage.fieldsName.token, token);
			localStorage.setItem(vars.localStorage.fieldsName.user, JSON.stringify(user));
			return { ...state, isAuthenticated: true, user };
		},
		logout: (state) => {
			localStorage.removeItem(vars.localStorage.fieldsName.token);
			localStorage.removeItem(vars.localStorage.fieldsName.user);

			localStorage.removeItem(vars.localStorage.fieldsName.uiUserPasswordUpdateNeeded);
			return { ...state, isAuthenticated: false, user: {} };
		},
	},
});

export const isAuthenticatedSelector = (state) => state?.auth?.isAuthenticated || false;
export const userSelector = (state) => state?.auth?.user || {};
export const isUserDataCompleteSelector = (state) => {
	const user = state?.auth?.user || {};
	const isAuthenticated = state?.auth?.isAuthenticated || false;
	return isAuthenticated && isUserDataComplete(user);
};

export const { actions, reducer } = slice;

export default reducer;
